module.exports = __webpack_public_path__ + "static/ro-workshops-6-fa24d5c1839e5068a5e1db3195843267.jpg";